import React from 'react'
import { Card, Col, ListGroup, Row } from 'react-bootstrap'

const FooterEN = () => {

  return (
    <>
        <footer className='no-border rounded-0 footer-wrapper'>
            <div className="footer-content container">
                <Row className='footer-top'>
                    <Col xs={{ span:4, offset:0 }} md={{ span:3, offset:0 }}>
                        <Card.Img className='' src={"/assets/footer/footer_paracosma _logo.png"} alt="" />
                    </Col>
                    <Col xs={{ span:4, offset:3 }} md={{ span:3, offset:5 }}>
                       <a href="https://www.facebook.com/paracosmaInc" target="_blank" rel="noreferrer"> <Card.Img className='footer-social-icon px-md-4' src={"/assets/footer/footer_fb.png"} alt="" /> </a>
                       <a href="https://www.instagram.com/paracosmainc" target="_blank" rel="noreferrer"> <Card.Img className='footer-social-icon px-md-4' src={"/assets/footer/footer_ig.png"} alt="" /> </a>
                       <a href="https://www.linkedin.com/company/paracosma/" target="_blank" rel="noreferrer"> <Card.Img className='footer-social-icon px-md-4' src={"/assets/footer/footer_linkedin.png"} alt="" /> </a>
                    </Col>
                </Row>

                <div className='product-border pt-4 pb-3'></div>
                <Row className='footer-mid-section py-2'>
                    <Col xs={{span:12,offset:0}} md={{span:4,offset:0}}>
                        <Card.Text className='footer-desc text-white pr-md-5 mr-md-5'>
                        Paracosma is an Augmented and Virtual Reality Solutions Provider. Paracosma services include custom AR/VR application development, virtual office and event production, and 3D content creation, including photorealistic 3D modeling as well as 360 video prod uction and distribution. Founded in 2016, Paracosma has over 100 employees in offices in the US, Japan and Nepal.
                        </Card.Text>
                    </Col>
                    <Col xs={{span:5,offset:0}} md={{span:3,offset:1}} className="footer-quicklink-container">
                        <Card.Title className='footer-mid-section-quicklink-header'>QUICK LINKS</Card.Title>
                        <ListGroup className='no-border quicklink-list text-white'>
                            <ListGroup.Item action href="https://www.paracosma.com" target="_blank">Home</ListGroup.Item>
                            <ListGroup.Item action href="/three-D-model">3D Modeling</ListGroup.Item>
                            <ListGroup.Item action href="/vr-development">VR Development</ListGroup.Item>
                            <ListGroup.Item action href="/digital-twins">Digital Twins</ListGroup.Item>
                            <ListGroup.Item action href="https://www.paracosma.com/#aboutus" target="_blank">About</ListGroup.Item>
                            <ListGroup.Item action href="https://blog.paracosma.com" target="_blank">Blog</ListGroup.Item>
                            <ListGroup.Item action href="https://www.paracosma.com/#contact-form" target="_blank">Contact</ListGroup.Item>
                        </ListGroup>
                    </Col>
                    <Col xs={{span:7,offset:0}} md={{span:4,offset:0}}>
                        <Card.Title className='footer-mid-section-header'>OUR OFFICES</Card.Title>
                        <Row className='py-2'>
                            <Col xs={2}>
                                <Card.Img className='footer-social-icon px-md-4' src={"/assets/footer/footer_usa.png"} alt="" />
                            </Col>
                            <Col xs={10} className="footer-office-location text-white">
                            2 Clarence Place, Unit #12 <br /> San Francisco, CA 94107 USA
                            </Col>
                        </Row>
                        <Row className='py-2'>
                            <Col xs={2}>
                                <Card.Img className='footer-social-icon px-md-4' src={"/assets/footer/footer_japan.png"} alt="" />
                            </Col>
                            <Col xs={10} className="footer-office-location text-white">
                            Tunnel Tokyo, 9th Floor Sumitomo <br />  Fudosan Osaki Garden Tower <br /> 1 - 1 - 1 Nishi - Shinagawa, <br />  Shinagawa - ku <br />  Tokyo 141 - 0033 Japan
                            </Col>
                        </Row>
                        <Row className='py-2'>
                            <Col xs={2}>
                                <Card.Img className='footer-social-icon px-md-4' src={"/assets/footer/footer_nepal.png"} alt="" />
                            </Col>
                            <Col xs={10} className="footer-office-location text-white">
                            TBI Plaza Nagpokhari Marg 44600 <br /> Gairidhara, Kathmandu Nepal
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>

            <Row className='footer-bottom-section'>
                <Col sm={{span:6, offset:3}} className="footer-bottom-text">
                    © Copyright {new Date().getFullYear()} by <a href="https://www.paracosma.com"  rel="noreferrer">Paracosma, Inc</a>. All right reserved.
                </Col>
            </Row>
        </footer>
        
      
    </>
  )
}

export default FooterEN
